import { render, staticRenderFns } from "./component-user-renewal.vue?vue&type=template&id=0b7c218e&scoped=true"
import script from "./component-user-renewal.vue?vue&type=script&lang=js"
export * from "./component-user-renewal.vue?vue&type=script&lang=js"
import style0 from "./component-user-renewal.vue?vue&type=style&index=0&id=0b7c218e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7c218e",
  null
  
)

export default component.exports